const UpdateData = [
  {
    date: 'Jun 9, 2025',
    data: {
      added: [
        {
          title: 'Quiz Mode for Country Picker Wheel',
          description:
            'We’ve introduced a brand new Quiz Mode to the Country Picker Wheel! Spin the wheel to get a random country name or flag, then guess the matching flag or country. After making your guess, generate a score certificate with your name and share it to challenge others. You can also create a quiz link to share with friends, allowing them to start their own quiz session. Test your skills, track your progress, and challenge friends to beat your score in this exciting new feature!',
          pages: [
            {
              url: '/tools/random-country-generator/',
              text: 'Country Picker Wheel',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Popup Msg Renamed to Result Title',
          description:
            'The Result Title still appears as the popup result header after each spin, and it now also serves as the title for the Result Page and the Score Page. This ensures a consistent title across the popup display and the final result pages.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'UI Improvements Across Tools',
          description:
            'The majority of form controls across tool sections have been updated to a black-and-white theme, replacing the previous colorful styles controlled by tool colors, for improved consistency and clarity.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'Mar 13, 2025',
    data: {
      added: [
        {
          title: 'State Picker Wheel',
          description:
            'Explore regions with the State Picker Wheel! Start by selecting a country from the provided list, then choose from its available states, provinces, or regions. Add them to the wheel and spin to get a random selection. Customize the result display to show the flag & name, flag only, or name only. Ready to discover your next destination?',
          pages: [
            {
              text: 'State Picker Wheel',
              url: '/tools/random-state-generator/',
            },
          ],
        },
        {
          title: 'MLB Picker Wheel',
          description:
            "Step up to the plate with the MLB Picker Wheel! Choose from all Major League Baseball teams or narrow it down by selecting your favorite league—American League or National League. Once you've made your selections, spin the wheel to randomly pick a team. Customize the result display to show the team’s logo & name, logo only, or name only. Ready to find your next favorite team?",
          pages: [
            {
              text: 'MLB Picker Wheel',
              url: '/tools/random-mlb-team-generator/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'New Sorting Options for Inputs',
          description:
            'We’ve added an Alphabetical Sort option to the MLB, NBA, NFL, Country, and State Picker Wheel! Now, you can sort inputs alphabetically or keep the original shuffle before spinning. Click Sort button and choose your preference for a better selection experience!',
          pages: [
            {
              text: 'Country Picker Wheel',
              url: '/tools/random-country-generator/',
            },
            {
              text: 'State Picker Wheel',
              url: '/tools/random-state-generator/',
            },
            {
              text: 'MLB Picker Wheel',
              url: '/tools/random-mlb-team-generator/',
            },
            {
              text: 'NBA Picker Wheel',
              url: '/tools/random-nba-team-generator/',
            },
            {
              text: 'NFL Picker Wheel',
              url: '/tools/random-nfl-team-generator/',
            },
          ],
        },
        {
          title: 'Country Multi-Select Fix & Flag Display Update',
          description:
            'We’ve fixed the Country Picker Wheel multi-select issue—now all countries are selectable! Plus, each country now shows its flag beside the name for a clearer, refreshed look. Try it out for a smoother experience!',
          pages: [
            {
              text: 'Country Picker Wheel',
              url: '/tools/random-country-generator/',
            },
          ],
        },
        {
          title: 'Reconnect Prompt for Expired Access Tokens',
          description:
            'We’ve fixed an issue in the Instagram Comment Picker Wheel that prevented participants from being fetched due to expired tokens. Now, you’ll be prompted to reconnect your Instagram account for a seamless experience!',
          pages: [
            {
              text: 'Instagram Comment Picker Wheel',
              url: '/tools/instagram-comment-picker/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'Jan 21, 2025',
    data: {
      added: [
        {
          title: 'NFL Picker Wheel',
          description:
            'Introducing the NFL Picker Wheel! Choose from all teams, or narrow it down by selecting your favorite conference—AFC or NFC. Once you’ve made your selections, spin the wheel to randomly pick a team. You can customize the result display to show the team’s logo & name, logo only, or name only. Ready to spin and discover the perfect team?',
          pages: [
            {
              text: 'NFL Picker Wheel',
              url: '/tools/random-nfl-team-generator/',
            },
          ],
        },
        {
          title: 'NBA Picker Wheel',
          description:
            'Get ready for the NBA Picker Wheel! Start by choosing teams from the entire league or select your preferred conference—Eastern or Western. Once you’ve made your choice, spin the wheel to randomly select an NBA team. Customize the result display to show the team logo & name, logo only, or name only. Let’s bring the thrill of basketball right to your fingertips!',
          pages: [
            {
              text: 'NBA Picker Wheel',
              url: '/tools/random-nba-team-generator/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Enhanced Color Wheel with Adjustable Darkness',
          description:
            'Explore the upgraded Color Picker Wheel! You can now easily adjust the darkness level to generate darker shades. Along with this, we’ve improved the UI for a seamless experience and added tooltips to make the color wheel even easier to use.',
          pages: [
            {
              text: 'Color Picker Wheel',
              url: '/tools/random-color-generator/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'Dec 15, 2024',
    data: {
      added: [
        {
          title: 'Color Picker Wheel',
          description:
            'Introducing the Color Picker Wheel for picking random colors! Spin instantly with the Color Wheel to get random colors and palettes; use Manual Input to add your own colors or select from predefined palettes; or upload an image to auto-extract a color palette or pick colors directly from the uploaded image using Image Picker. Let’s set up your wheel, spin it, and let creativity flow!',
          pages: [
            {
              text: 'Color Picker Wheel',
              url: '/tools/random-color-generator/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Enhanced Instagram Comment Picker Wheel',
          description:
            'You can now search posts directly using an Instagram post URL. Additionally, the winner pop-up now shows not only the winner’s username but also their comment on the post. In the winners list, you can view each winner’s comment again and visit their Instagram profile using the “View Profile” button.',
          pages: [
            {
              text: 'Instagram Comment Picker Wheel',
              url: '/tools/instagram-comment-picker/',
            },
          ],
        },
        {
          title: 'Preset Groups Issues Fixed ',
          description:
            'There are several issues from the preset groups in Team Picker Wheel. They are fixed now ',
          pages: [
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
          ],
        },
        {
          title: 'Handle Duplicate Names',
          description:
            'When there are same names added, Team Picker Wheel will add count for the newly added name.',
          pages: [
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
          ],
        },
        {
          title: 'Improve On The Tab Navigation',
          description:
            'It is now more user friendly when you use "Tab" key to navigate across the user interface.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Embed Wheel Reset Button Not Working - Fixed',
          pages: [
            {
              text: 'Embed Wheel',
              url: '/embed-tutorial/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'Sep 10, 2024',
    data: {
      added: [],
      updated: [
        {
          title: 'Result Page Customization',
          description:
            'We’ve added the ability to customize your result page! You can now personalize your certificate by adding animated confetti, static effects, and changing the background to suit your style.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Pop-Up Result Share Feature Update',
          description:
            'You can now generate a result page for each individual pop-up result. For multiple results, you can still generate a combined result page from the All Results view.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'Aug 28, 2024',
    data: {
      added: [
        {
          title: 'Instagram Comment Picker Wheel',
          description:
            'Introducing the Instagram Comment Picker Wheel to generate a list of random winners from the commenters on your Instagram post for any giveaway event.',
          pages: [
            {
              text: 'Instagram Comment Picker Wheel',
              url: '/tools/instagram-comment-picker/',
            },
          ],
        },
        {
          title: 'Result Page',
          description:
            'You can now generate a result page for your results obtained from multiple spins by clicking the "Open Results" button in the All Results view. The result page can later be shared as a link or saved as image, making it easy to share all results at once. Note: The background color and tool colors will carry over to the result page.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Improve Pop-Up Result Share Feature',
          description:
            'You can now save the individual pop-up result as an image or share it on social media. On mobile, the result image is automatically included in the share. The pop-up result also features a theme color that matches the chosen tool color. Note: The certification feature has been replaced by the new "Result Page" feature (see above "Added" section for details).',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Improve Share Link Feature',
          description:
            'You can now share the Picker Wheel link along with a preset message directly to Facebook, Twitter, Telegram, or WhatsApp. On mobile, the wheel image is automatically included in the share.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Update All Results View',
          description:
            'The All Results view now includes paging for easier navigation, displaying ten results per page. The certificate generation feature has been removed and replaced with the "Open Results" button, which now leads directly to the new "Result Page" feature (see above "Added" section for details).',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'SPIN Button Animation and Color-Changing',
          description:
            'You can now disable the SPIN button animation and color-changing. Some people might not be comfortable when seeing the animation.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'May 9, 2024',
    data: {
      added: [
        {
          title: 'Shortcut Key to Start Spinning',
          description:
            'You can press the shortcut key CTRL + Enter to start the spin. Or press Tab / Enter / Esc to switch / select / close from the result popup.',
        },
        {
          title: 'Initial Spinning',
          description:
            'The wheel is spinning slowly before the 1st spin. This setting can be turned off in Tool Settings.',
        },
      ],
      updated: [
        {
          title: 'Wheel Spinning Algorithm',
          description:
            'Improved the spinning algorithm to make the spinning behave like the real wheel spinning.',
        },
        {
          title: 'Spin Button Animation',
          description: 'Improved the spin button animation.',
        },
        {
          title: 'Wheel Fonts',
          description:
            'Changed the font that is drawn on the wheel to an educational-friendly font.',
        },
        {
          title: 'High Resolution Wheel',
          description: 'The resolution of the wheel is improved.',
        },
      ],
    },
  },
  {
    date: 'Apr 3, 2024',
    data: {
      added: [
        {
          title: 'Account - Change Email',
          description:
            'You can now change the email yourself at the account page. This is only available for Password login method.',
        },
        {
          title: 'Account - Option for Changing Google Login to Password Login',
          description:
            'You can change from Google login method to Password login method yourself at the account page. This changing is irreversible.',
        },
        {
          title: 'Inputs Count for All Tools',
          description:
            'You can know the number of inputs that are shown on the wheel.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
      ],
      updated: [],
    },
  },
  {
    date: 'Jan 16, 2024',
    data: {
      added: [
        {
          title: 'Features of Team Picker Wheel',
          description:
            'We added several features for Team Picker Wheel. We added Fullscreen, Hide Inputs Section, Preset Group Members, Include/Exclude Participants, Pick Representatives, Animation, and Spin Behavior Setting.',
          pages: [
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
          ],
        },
        {
          title: 'Random Digits of Number Picker Wheel',
          description:
            'For the Spin and Combine mode, we have named it now as Random Digits mode. You now can choose how many digits (up to 6) you want and set the number range for each digit.',
          pages: [
            {
              text: 'Number Picker Wheel',
              url: '/tools/random-number-generator/',
            },
          ],
        },
        {
          title: 'Save File Enabled for Number Picker Wheel',
          description: `Now Number Picker Wheel can save file like what main Picker Wheel does. So you don't need to repeat typing everytime.`,
          pages: [
            {
              text: 'Number Picker Wheel',
              url: '/tools/random-number-generator/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Update User Interface and Improve Algorithm',
          description:
            'We have modified some icons, user interface and flow to provide you a better experience.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Fixed No Sound when Using Opera Browser',
          description: '',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'Sep 18, 2023',
    data: {
      added: [
        {
          title: 'Share System',
          description:
            'Introduce a new share system. All users can share from files or share as guest. Premium users can create a share link with banners and ads removed.',
          pages: [
            {
              text: 'Picker Wheel',
              url: '/',
            },
            {
              text: 'Image Picker Wheel',
              url: '/tools/random-image-generator/',
            },
          ],
        },
        {
          title: 'More Customizations for Personalized Plan',
          description:
            'Premium users can do more customizations now: sounds, spin button, background etc',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Title',
          description:
            'The title location has been changed. Added description and popup title.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Spin Count',
          description:
            'You can go to the spin behavior setting to turn on the spin count display.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Update User Interface and Improve Algorithm',
          description:
            'Improve user interface and flow to provide a better experience.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Improve New Wheel Tab Feature',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Result Is Also Saved for Team Picker Wheel',
          description:
            'The result generated by Team Picker Wheel will also be saved when you save the file so that you can view it in the future.',
          pages: [
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
          ],
        },
        {
          title: 'Fixed Team Name Not Shared',
          description: '',
          pages: [
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'May 3, 2023',
    data: {
      added: [
        {
          title: 'Date Picker Wheel',
          description:
            'Introduce the Date Picker Wheel to generate a random date from a list of date inputs.',
          pages: [
            {
              text: 'Date Picker Wheel',
              url: '/tools/random-date-generator/',
            },
          ],
        },
        {
          title: 'New Wheel Tab',
          description:
            'You can now open new wheel tabs to easily switch between different wheels.',
          pages: [
            {
              text: 'Picker Wheel',
              url: '/',
            },
            {
              text: 'Image Picker Wheel',
              url: '/tools/random-image-generator/',
            },
          ],
        },
        {
          title: 'Hide Gender / Label',
          description:
            'You can hide gender or label from the input list for Team Picker Wheel.',
          pages: [
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Minor UI Change',
          description: '',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Improved Tablet Full Screen Compatibility',
          description: '',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'Apr 13, 2023',
    data: {
      added: [
        {
          title: 'Instant Save',
          description:
            'You can quickly save your modified list via the save button.',
          pages: [
            {
              text: 'Picker Wheel',
              url: '/',
            },
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
            {
              text: 'Image Picker Wheel',
              url: '/tools/random-image-generator/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Fixed Import Inputs Copy Paste Bug',
          description:
            'Fixed bug which cause page unresponsive during import inputs by copy paste.',
          pages: [
            {
              text: 'Picker Wheel',
              url: '/',
            },
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
          ],
        },
        {
          title: 'Save, Save As, Open, Edit and Delete Position Change',
          description: 'Change user interface.',
          pages: [
            {
              text: 'Picker Wheel',
              url: '/',
            },
            {
              text: 'Team Picker Wheel',
              url: '/tools/random-team-generator/',
            },
            {
              text: 'Image Picker Wheel',
              url: '/tools/random-image-generator/',
            },
          ],
        },
        {
          title: 'Duplicate Button Now Not Copy Status',
          description:
            'Duplicate each input will not duplicate its status e.g. count.',
          pages: [
            {
              text: 'Picker Wheel',
              url: '/',
            },
            {
              text: 'Image Picker Wheel',
              url: '/tools/random-image-generator/',
            },
          ],
        },
        {
          title: '404 Page Sometime (Safari) When Open Share Link',
          description: 'Fixed bug.',
        },
      ],
    },
  },
  {
    date: 'Mar 21, 2023',
    data: {
      added: [
        {
          title: 'Pie with Text and Image',
          description: 'Now you can apply both Text and Image to each pie.',
          pages: [
            {
              text: 'Picker Wheel',
              url: '/',
            },
          ],
        },
        {
          title: 'Duplicate Button',
          description: 'Each input now comes with the duplicate button.',
          pages: [
            {
              text: 'Picker Wheel',
              url: '/',
            },
            {
              text: 'Image Picker Wheel',
              url: '/tools/random-image-generator/',
            },
          ],
        },
      ],
      updated: [
        {
          title: 'Major Firmware Update',
          description: 'Improved some algorithms and updated all firmware.',
          pages: [
            {
              text: 'All',
              url: '/',
            },
          ],
        },
        {
          title: 'Minor User Interface Change',
          description: 'User interface in the inputs section is changed.',
          link: {
            url: '/feedback/',
            text: '[Let us know if not good]',
          },
          pages: [
            {
              url: '/',
              text: 'Picker Wheel',
            },
          ],
        },
        {
          title: 'Fixed Percent (%) Sign Not Showed Error',
          pages: [
            {
              url: '/embed-tutorial/',
              text: 'Embed Wheel',
            },
          ],
        },
        {
          title: 'Fixed No Country Options Error',
          description: 'The error happened when no country options are left.',
          pages: [
            {
              url: '/tools/random-country-generator/',
              text: 'Country Picker Wheel',
            },
          ],
        },
      ],
    },
  },
  {
    date: 'Dec 30, 2022',
    data: {
      added: [
        {
          title: 'Country Picker Wheel',
          description: 'Launched the Country Picker Wheel tool.',
          link: {
            url: '/tools/random-country-generator/',
            text: '[See It]',
          },
        },
      ],
      updated: [],
    },
  },
  {
    date: 'Dec 1, 2022',
    data: {
      added: [
        {
          title: 'More Grouping Functions for Team Picker Wheel',
          description:
            'Added more grouping functions. E.g. distribution mode, hide gender/label, and pick quantity.',
        },
        {
          title: 'Embed Picker Wheel - More Customization',
          description:
            'Added more customization for the Embed Picker Wheel. E.g.: weight, .csv upload, title, confetti, text color, background color, wheel colors and hiding logo.',
          link: {
            url: '/embed-tutorial/',
            text: '[See it]',
          },
        },
      ],
      updated: [
        {
          title:
            'Improve View/Import Flexibility for Picker Wheel and Team Picker Wheel',
          description:
            'You can now import list of inputs from .csv excel file. You can also include the weight formula when preparing the inputs.',
        },
        {
          title: 'Use Arrow Keyboard to Move Across the Inputs',
          description:
            'You can now use the arrow up or down keyboard to move across the inputs so that can easily modify your inputs.',
        },
      ],
    },
  },
  {
    date: 'August 12, 2022',
    data: {
      added: [
        {
          title: 'Formula Input Method for Number Picker Wheel',
          description:
            'We introduce another easy input method for Number Picker Wheel.',
          link: {
            url: '/tools/random-number-generator/',
            text: '[See It]',
          },
        },
        {
          title: 'Introduce "File" Storage',
          description:
            'File can be used to save your current list ("List" type) and your created share link ("Share" type). So that you can access/edit/delete next time. Applicable for main Picker Wheel, Team Picker Wheel and Image Picker Wheel. Read from the tutorial section from each tool to understand about it.',
        },
        {
          title: 'Allow Copy or Spin Only Share Link',
          description:
            'You can configure a share link whether the people can copy your inputs to become their wheel or they can only spin the wheel. People who open the link will be in share view mode.',
        },
      ],
      updated: [
        {
          title: 'Include Settings When Saving Current List File',
          description:
            'You can choose whether should include tools settings when saving your list into file.',
        },
        {
          title: 'Added Exclude Field for Number Picker Wheel',
          description:
            'For range input method, you can now exclude certain numbers from the range.',
        },
        {
          title: 'Fixed Team Name Missing for Team Picker Wheel',
          description:
            'We fixed the team name missing for Team Picker Wheel when export to the CSV file.',
        },
      ],
    },
  },
  {
    date: 'June 19, 2022',
    data: {
      added: [
        {
          title: 'Sound Volume Control',
          description:
            'You can now easily control the sound volume at the wheel section. (Only available in desktop version). The default sound volume is set at 0.5. ',
        },
        {
          title: 'Hide Inputs Section',
          description:
            'You can hide inputs section now. (Only available in desktop version)',
        },
      ],
      updated: [],
    },
  },
  {
    date: 'May 28, 2022',
    data: {
      added: [
        {
          title: 'Premium Plan - Personalized',
          description:
            'You may upgrade to Personalized plan to remove ads, get unlimited save lists, colors customization, banner/logo placement.',
          link: {
            url: '/plan/',
            text: '[See The Plan]',
          },
        },
      ],
      updated: [],
    },
  },
  {
    date: 'May 22, 2022',
    data: {
      added: [
        {
          title: 'Drag and Drop',
          description:
            'You may drag and drop to rearrange your inputs now. Available in Picker Wheel and Image Picker Wheel.',
        },
      ],
      updated: [
        {
          title: 'Upload Multiple Images',
          description:
            'You may now upload multiple images at once. Available in Picker Wheel.',
        },
      ],
    },
  },
  {
    date: 'April 19, 2022',
    data: {
      added: [
        {
          title: 'Delete Saved List',
          description: 'You may delete your own saved list now.',
        },
        {
          title: 'Delete Account',
          description:
            'You may delete your own account on your profile page now.',
        },
      ],
      updated: [
        {
          title: 'Increase Number of Save Lists to 15',
          description:
            'We increase the number of save lists from 10 to 15 lists. You may save data for more purposes now.',
        },
        {
          title: 'Improved Share Link Algorithm',
          description:
            'OLD: when opening a share link, the data will permanently replace existing browser data. NEW: the data will only temporarily replace existing browser data when browsing this particular URL.',
        },
      ],
    },
  },
  {
    date: 'January 6, 2022',
    data: {
      added: [],
      updated: [
        {
          title: 'Changed New Cert Design',
          description: 'We updated the design of certification.',
        },
      ],
    },
  },
  {
    date: 'January 1, 2022',
    data: {
      added: [
        {
          title: 'Certification',
          description:
            'You can now generate a cert for your result obtained from the spin. The cert generator is located below the result and also in the All Results view. You can share the cert or save the cert as image.',
        },
      ],
      updated: [
        {
          title: 'Major Software Packages Updates',
          description:
            'We updated the application with the latest software packages in order to provide the best possible experience. If you encountered issue, please let us know.',
          link: {
            url: '/feedback/',
            text: '[Feedback Us]',
          },
        },
      ],
    },
  },
  {
    date: 'November 30, 2021',
    data: {
      added: [],
      updated: [
        {
          title: 'New Songs',
          description: 'Added new songs for start, spinning and ending sounds.',
        },
        {
          title: 'New Themes for Tool Colors',
          description: 'Added "Mono" theme and "Young" theme tool colors.',
        },
        {
          title: 'New Theme for Background Color',
          description: 'Added "Mono" theme background color.',
        },
      ],
    },
  },
  {
    date: 'November 10, 2021',
    data: {
      added: [
        {
          title: 'Mystery Spin',
          description:
            'Hide your inputs on the wheel. People can only see the result when done spinning. Available at Tool Settings -> Spin Behavior.',
        },
        {
          title: 'Download All Results Image',
          description:
            'You have an option now to download all results/scores as an image inside the all results view.',
        },
        {
          title: 'Versioning',
          description:
            'Added versioning at the bottom of each tool, you can see what are the latest updates by clicking it.',
        },
      ],
      updated: [
        {
          title: 'Full Screen Available for Tablet',
          description:
            'Unlocked the full-screen feature for tablet devices as well. Now full screen can be turned on on desktop and tablet devices.',
        },
        {
          title: 'Spinning Algorithm Enhanced',
          description:
            'Enhanced spinning and randomness algorithm for all the wheel tools.',
        },
        {
          title: 'Tools Menu',
          description:
            'Added tools menu button at the top right navigation menu. You can access any tool quickly. Available for tablet and desktop devices.',
        },
        {
          title: 'Video Tutorials',
          description: 'Added more video tutorials.',
          link: {
            url: '/video-gallery/',
            text: '[Video Gallery]',
          },
        },
      ],
    },
  },
  {
    date: 'October 25, 2021',
    data: {
      added: [
        {
          title: 'New Music',
          description:
            'Added new 3 spinning and 3 ending pieces of music e.g., Halloween. You can check them at the Tool Settings section -> Confetti & Sound.',
        },
      ],
      updated: [
        {
          title: 'Longer Spinning - Team Picker Wheel',
          description:
            'Made spinning slightly longer for Team Picker Wheel due to request.',
          link: {
            url: '/tools/random-team-generator/',
            text: '[Team Picker Wheel]',
          },
        },
      ],
    },
  },
  {
    date: 'October 21, 2021',
    data: {
      added: [
        {
          title: 'Weight',
          description:
            'We have added the weight function so that you can change the portion size of each input. This is optional and turned off by default.',
          link: {
            url: '/',
            text: '[Picker Wheel]',
          },
        },
        {
          title: 'Image Input Support',
          description:
            'You can now add image input mix together with your text input at the main Picker Wheel page.',
          link: {
            url: '/',
            text: '[Picker Wheel]',
          },
        },
        {
          title: 'Video Gallery Page',
          description:
            'Added video gallery page to guide or help you learn more about Picker Wheel. We will continue to add more.',
          link: {
            url: '/video-gallery/',
            text: '[Video Gallery]',
          },
        },
      ],
      updated: [
        {
          title: 'Tutorial Section',
          description:
            'We updated the tutorial content below the wheel section. You can read from there to understand the latest features.',
          link: {
            url: '/',
            text: '[Picker Wheel]',
          },
        },
      ],
    },
  },
  {
    date: 'September 28, 2021',
    data: {
      added: [
        {
          title: 'Live On Instagram',
          description:
            'We are now live on Instagram. Please follow us to get more info and updates on Picker Wheel.',
          link: {
            url: 'https://instagram.com/pickerwheel/',
            text: 'https://instagram.com/pickerwheel/',
            external: true,
          },
        },
      ],
      updated: [],
    },
  },
  {
    date: 'September 21, 2021',
    data: {
      added: [
        {
          title: 'Custom Team Names',
          description:
            'You may set your custom team names for Team Picker Wheel.',
        },
        {
          title: 'Number of People/Group',
          description:
            'You may set the number of people/group as the requirement for doing grouping in Team Picker Wheel.',
        },
      ],
      updated: [
        {
          title: 'Expand Save Lists to 10 Lists',
          description:
            'We have expanded the save lists from 7 to 10 lists. You may save more data for more purposes now.',
        },
      ],
    },
  },
  {
    date: 'August 20, 2021',
    data: {
      added: [
        {
          title: 'Dark Mode',
          description:
            'We added dark mode for Picker Wheel, you can now switch to dark mode from the menu.',
        },
      ],
      updated: [
        {
          title: 'Load/Save Function Improved',
          description:
            'Some people have weird behaviors with the save function of Picker Wheel, it is now improved and the problem is solved.',
        },
      ],
    },
  },
  {
    date: 'August 2, 2021',
    data: {
      added: [
        {
          title: 'Added Random Initial Angle',
          description:
            'The wheel starting angle will be random (default) when new input is inserted. You can change the setting in the Tool Settings -> Spin Behavior.',
        },
      ],
      updated: [
        {
          title: 'Spinning Algorithm',
          description:
            'We have improved the spinning algorithm so it is closed to the real spinning behavior.',
        },
        {
          title: 'Spin Behavior Settings',
          description:
            'We have changed the default speed to 5 and the default duration to 9 seconds to adapt to the new spinning algorithm. We also extended the duration setting up to 30 seconds. Manually stop feature is now using a predefined speed without being affected by custom speed control.',
        },
      ],
    },
  },
  {
    date: 'July 8, 2021',
    data: {
      added: [
        {
          title: 'Added Title Section',
          description: 'You can now display a title for your wheel/tool.',
        },
      ],
      updated: [
        {
          title: 'Share Link & Save List Support Title Content',
          description:
            'When you create a share link or save a list, if title section is enabled, it will be included in the share or save.',
        },
        {
          title: 'Share Link',
          description:
            'You can now share your existing inputs/configuration for Yes No Picker Wheel, Number Picker Wheel and Letter Picker Wheel. We no longer support the feature which includes existing results in the share link.',
        },
      ],
    },
  },
  {
    date: 'Jun 28, 2021',
    data: {
      added: [
        {
          title: 'Added Custom Sound Effects',
          description:
            'You can now change the sound effects during spinning and after ending at the Tool Settings section.',
        },
      ],
      updated: [],
    },
  },
  {
    date: 'May 24, 2021',
    data: {
      added: [],
      updated: [
        {
          title: 'Improve Team Picker Wheel Performance',
          description:
            'Speed up rendering and is tested up to 500 inputs with 100 groups for Team Picker Wheel. Fix minor issues when saving huge groups result as an image.',
        },
      ],
    },
  },
  {
    date: 'May 18, 2021',
    data: {
      added: [],
      updated: [
        {
          title: 'Improve Wheel Rendering Speed',
          description:
            'Speed up rendering and is tested up to 1000 inputs for main Picker Wheel and Number Picker Wheel. Speed up rendering and is tested up to 100 inputs for Image Picker Wheel.',
        },
      ],
    },
  },
  {
    date: 'April 16, 2021',
    data: {
      added: [
        {
          title: 'Embed Wheel Link Generator',
          description: 'It helps you to easily create an embed wheel link.',
        },
      ],
      updated: [
        {
          title: 'New Embed Wheel Design',
          description:
            'We have improved the embed wheel design, and now you will also have 3 action modes available.',
        },
      ],
    },
  },
  {
    date: 'March 29, 2021',
    data: {
      added: [
        {
          title: 'Add Full Screen Mode',
          description:
            'Now you have the full-screen mode for all the wheel tools.',
        },
        {
          title: 'Add Show All Results',
          description:
            'Now you can see all your selected results and also the accumulated scores (applied to Picker Wheel and Image Picker Wheel).',
        },
      ],
      updated: [],
    },
  },
  {
    date: 'March 22, 2021',
    data: {
      added: [
        {
          title: 'Add Account System',
          description:
            'You now can sign up to the Picker Wheel to enjoy more benefits, e.g.: permanently store your save lists in the cloud database, access the save lists across multiple devices.',
        },
      ],
      updated: [
        {
          title: 'Migrate Save Lists from Browser Storage to Cloud Database',
          description:
            'We are now using a cloud database to store all your save lists so that you can access them through different devices.',
        },
      ],
    },
  },
  {
    date: 'January 21, 2021',
    data: {
      added: [],
      updated: [
        {
          title:
            'View/Import Inputs Button for Picker Wheel and Team Picker Wheel',
          description:
            'Some told us it was hard to copy/duplicate the existing inputs. Now you may view and copy your existing inputs easily as well as add a list of new inputs.',
        },
        {
          title:
            'Show Number of Inputs for Picker Wheel and Image Picker Wheel',
          description: 'Display the total number of inputs inserted.',
        },
      ],
    },
  },
  {
    date: 'December 27, 2020',
    data: {
      added: [],
      updated: [
        {
          title: 'Add More Save Lists',
          description: 'Expanded the number of save lists to 7.',
        },
        {
          title: "Improve Wheel's Texts Readability",
          description:
            'Improved the text readability when have more wheel pies.',
        },
      ],
    },
  },
  {
    date: 'December 22, 2020',
    data: {
      added: [],
      updated: [
        {
          title: 'Improve Tools Share - All Tools',
          description:
            'You now can share all the wheels/tools with your current texts/images and settings.',
        },
      ],
    },
  },
  {
    date: 'December 9, 2020',
    data: {
      added: [],
      updated: [
        {
          title: 'Add More Colors - Tool Settings',
          description: 'We added more tool colors and background colors.',
        },
      ],
    },
  },
  {
    date: 'November 30, 2020',
    data: {
      added: [],
      updated: [
        {
          title: 'Wheel Pies Separator - All Picker Wheel',
          description:
            'Added separator between the wheel pies with same color.',
        },
        {
          title: 'Support Same Input Value - Main / Image Picker Wheel',
          description: 'Now fully support same input value and image.',
        },
      ],
    },
  },
  {
    date: 'November 2, 2020',
    data: {
      added: [
        {
          title: 'Spin and Combine Input Types - Number Picker Wheel',
          description: 'You can now get a random number from 0 to 99999.',
        },
      ],
      updated: [
        {
          title: 'Fixed Freeze Start Button - Team Picker Wheel',
          description:
            "Solved start button can't be clicked for certain use cases.",
        },
      ],
    },
  },
  {
    date: 'October 18, 2020',
    data: {
      added: [
        {
          title: 'Multiple Save Lists - Team Picker Wheel',
          description: 'You can now save multiple lists for Team Picker Wheel.',
        },
        {
          title: 'Multiple Save Lists - Image Picker Wheel',
          description:
            'You can now save multiple lists for Image Picker Wheel.',
        },
      ],
      updated: [],
    },
  },
  {
    date: 'October 13, 2020',
    data: {
      added: [
        {
          title: 'Latest Updates Page',
          description:
            'We started this page to let every user get a notice about our new and improved features.',
        },
      ],
      updated: [],
    },
  },
  {
    date: 'October 9, 2020',
    data: {
      added: [
        {
          title: 'Manual Stop Button',
          description: `We added the manual stop button. Now you can let the wheel stopped itself (default) or stopped by yourself. Enable it at "Tool Settings" -> "Spin Behavior".`,
        },
      ],
      updated: [],
    },
  },
  {
    date: 'September 25, 2020',
    data: {
      added: [
        {
          title: 'Image Picker Wheel',
          description: 'Now you can spin the wheel using images inputs.',
          link: {
            url: '/tools/random-image-generator/',
            text: 'See here',
          },
        },
        {
          title: 'Multiple Save Lists',
          description:
            'Many people are asking for this. And now we have it. You can now save up to 4 lists on the main Picker Wheel.',
          link: {
            url: '/',
            text: 'Read the instruction at Section 2.1.',
          },
        },
      ],
      updated: [
        {
          title: 'Smooth Spinning',
          description:
            'We improved the spinning smoothness when having more inputs. e.g. 100 inputs.',
        },
      ],
    },
  },
  {
    date: 'Since Long Time Ago',
    data: {
      added: [
        {
          title: 'Picker Wheel',
          description:
            'We created the Picker Wheel site. Fixing bugs, adding new features, and improving them since then.',
        },
      ],
      updated: [],
    },
  },
]

// const BASE_VERSION = 50
export const LatestData = {
  item: UpdateData[0],
  version: 50 + UpdateData.length,
}

export default UpdateData
